<template>
    <div>
        <b-container fluid align-content="center">
          <b-row>
            <b-col cols="12" md="6" class="text-center">
                <v-select
                    placeholder="source language"
                    :options="qtSourceLanguages"
                    class="my-2"
                    v-model="sourceLanguage"
                     :reduce="language => language.code"
                    >
                      <template slot="option" slot-scope="option" :value="option.code">
                        <!-- <span class="flag-icon ml-0 mr-2 small" :class="'flag-icon-' + option.flag"></span>  -->
                        {{ option.label }}
                        </template>
                </v-select>
                <b-form-textarea
                    id="textarea"
                    v-model="sourceText"
                    placeholder="Enter something..."
                    rows="12"
                ></b-form-textarea>
                <p class="text-right"><small class="text-muted">{{ inputLength }} / 2000 characters</small></p>
            </b-col>
            <b-col cols="12" md="6" class="text-center">
                <v-select
                    placeholder="target language"
                    :disabled=disabledTargetLanguage
                    :options="targetLanguages"
                    class="my-2"
                    v-model="targetLanguage"
                     :reduce="language => language.code"
                    >
                      <template slot="option" slot-scope="option" :value="option.code">
                        <!-- <span class="flag-icon ml-0 mr-2 small" :class="'flag-icon-' + option.flag"></span>  -->
                        {{ option.label }}
                        </template>
                </v-select>
                <b-form-textarea
                    id="output_text"
                    v-model="translatedText"
                    placeholder="Translation"
                    rows="12"
                    readonly
                ></b-form-textarea>
                <div class="float-right" v-b-tooltip.hover title="Copy">
                  <a href="#" @click="copyToClipboard('output_text')"
                    ><span style="color:#aaa"><b-icon icon="subtract"></b-icon></span
                  ></a>
                </div>
            </b-col>
            </b-row>
             <b-alert
                :show="dismissCountDown"
                dismissible
                :variant="alertType"
                @dismissed="dismissCountDown=0"
              >{{ alertText }}</b-alert>
            <b-row>
              <b-col cols="11" class="text-center">
                <b-button type="button"
                          variant="primary"
                          size="md"
                          class="mx-3"
                          :disabled="disabledSubmitButton"
                          @click.prevent="quickTranslate">
                  TRANSLATE
                </b-button>
                <!-- <b-button type="button" variant="primary" @click.prevent="reverseLanguages">
                  <b-icon icon="arrow-left-right"></b-icon> REVERSE
                </b-button> -->
              </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
/**
 * @todo: Input by voice on Chrome
 * @todo: Language switching (though language pairs are assymetric)
 */
import apiClient from '@/services/api_client_saas.js'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      sourceText: '', // for form field submission
      sourceLanguage: '', //
      targetLanguage: '',
      translatedText: '', // output from this
      tasks: [], // for documents submitted,
      alertType: 'warning',
      alertText: '',
      show_alert: false,
      dismissCountDown: 0
    }
  },
  computed: {
    inputLength () {
      return this.sourceText.length
    },
    disabledTargetLanguage () {
      return !this.sourceLanguage
    },
    disabledSubmitButton () {
      return !this.sourceLanguage || !this.targetLanguage
    },
    ...mapGetters([
      'qtSourceLanguages',
      'qtTargetLanguages',
      'defaultApiKey'
    ]),
    targetLanguages () {
      if (this.sourceLanguage) {
        const outputList = this.qtTargetLanguages(this.sourceLanguage)
        return outputList
      }
      return []
    }
  },
  methods: {
    reverseLanguages () {
      this.sourceText = this.translatedText
      this.translatedText = ''
      this.sourceLanguage = this.targetLanguage
      this.targetLanguage = ''
    },
    quickTranslate () {
      const t0 = performance.now()
      apiClient.post('/translate/quick', {
        source_language: this.sourceLanguage,
        target_language: this.targetLanguage,
        source_text: this.sourceText,
        api_key: this.defaultApiKey
      }, {
        headers: { api_key: this.defaultApiKey }
      }).then((response) => {
        this.translatedText = response.data
        const t1 = performance.now()
        console.log('Call to quickTranslate took ' + (t1 - t0) + ' milliseconds.')
      }).catch((error) => {
        if (error.response.status === 400) {
          // console.log(error.response.data)
          this.alertType = 'danger'
          this.alertText = error.response.data.error
          this.dismissCountDown = 30
        }
        if (error.response.status === 401) {
          // console.log(error.response.data)
          this.alertType = 'danger'
          this.alertText = error.response.data.error
          this.dismissCountDown = 30
        }
      })
    },
    copyToClipboard (id) {
      // var element = document.querySelector('#' + id)
      var element = document.getElementById(id)
      var range
      if (document.selection) {
        // IE
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
      document.execCommand('copy')
      window.getSelection().removeAllRanges()
      this.$bvToast.toast('copied to clipboard', {
        autoHideDelay: 2000,
        // title: `Variant ${variant || 'default'}`,
        variant: 'success',
        solid: false
      })
    }
  },
  watch: {
    sourceLanguage: {
      handler (val) {
        const outputList = this.qtTargetLanguages(val)
        if (outputList.length === 1) { // auto-set the output if only 1 option
          this.targetLanguage = outputList[0].code
        } else if (this.targetLanguage in outputList === false) { // ensure a previously-set target language is actually valid in the output list
          this.targetLanguage = null
        }
      }
    }
  }
}
</script>
